// Utility to build consistent telemetry labels from path segments
// Ensures kebab-case and joins with '-'
export function buildLabel(root: string, ...segments: Array<null | number | string | undefined>): string {
  const normalize = (value: number | string) =>
    String(value)
      .trim()
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "");

  const parts: string[] = [];
  if (root) parts.push(normalize(root));
  for (const seg of segments) {
    if (seg === undefined || seg === null) continue;
    const normalized = normalize(seg);
    if (normalized) parts.push(normalized);
  }
  return parts.join("-");
}

export default buildLabel;
